<template>
  <article
    class="col-md-18"
    :class="{
      loading: isLoading,
    }"
  >
    <h1>Reseller</h1>
    <form novalidate>
      <div class="form-group row">
        <label for="name" class="col">Name:</label>
        <input
          type="text"
          class="form-control col col-12"
          :class="{
            'is-invalid': $v.reseller.displayName.$error,
          }"
          id="name"
          v-model="reseller.displayName"
          v-if="edit"
          @change="$v.reseller.displayName.$touch()"
        />
        <span v-if="!edit" class="col">{{ reseller.displayName }}</span>
      </div>
      <div class="form-group row">
        <label for="jasperWirelessCode" class="col"
          >Jasper wireless code:</label
        >
        <input
          type="text"
          class="form-control col col-12"
          :class="{
            'is-invalid': $v.reseller.jasperWirelessCode.$error,
          }"
          id="jasperWirelessCode"
          v-model="reseller.jasperWirelessCode"
          v-if="edit"
          @change="$v.reseller.jasperWirelessCode.$touch()"
        />
        <span v-if="!edit" class="col">{{ reseller.jasperWirelessCode }}</span>
      </div>
      <button
        type="button"
        @click.prevent="edit = true"
        class="btn btn-sm btn-primary mr-2"
        v-if="!edit"
      >
        Edit
      </button>
      <button
        type="submit"
        @click.prevent="save()"
        class="btn btn-sm btn-primary mr-2"
        v-if="edit"
      >
        Save
      </button>
      <button
        type="button"
        @click.prevent="edit = false"
        class="btn btn-sm btn-primary mr-2"
        v-if="edit && reseller.id"
      >
        Cancel
      </button>
    </form>

    <div v-if="!newReseller">
      <h2 class="mt-3">Rateplans</h2>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Name</th>
            <th scope="col">Jasper wireless code</th>
            <th scope="col">enabled</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="plan in rateplans" :key="plan.id">
            <td>{{ plan.id }}</td>
            <td>{{ plan.displayName }}</td>
            <td>{{ plan.jasperWirelessCode }}</td>
            <td>{{ plan.enabled }}</td>
            <td>
              <a
                href="#"
                @click="removePlan(plan)"
                class="btn btn-primary btn-sm"
              >
                Remove
              </a>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="5">
              <select
                v-model="planToAdd"
                class="custom-select d-inline-block w-auto mr-2"
              >
                <option disabled>pick rateplan</option>
                <option
                  v-for="rateplan in filteredRateplans"
                  :key="rateplan.id"
                  :value="rateplan"
                  >{{ rateplan.displayName }}</option
                >
              </select>
              <a
                href="#"
                @click="addPlan(planToAdd)"
                class="btn btn-primary btn-sm"
                :class="{ disabled: !planToAdd }"
              >
                Add rateplan
              </a>
            </td>
          </tr>
        </tfoot>
      </table>

      <h2 class="mt-3">Users</h2>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Name</th>
            <th scope="col">Roles</th>
            <th scope="col">enabled</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td>{{ user.id }}</td>
            <td>{{ user.username }}</td>
            <td>{{ user.roles.join(', ') }}</td>
            <td>{{ user.enabled }}</td>
            <td>
              <a
                href="#"
                @click="editUser(user)"
                class="btn btn-primary btn-sm"
              >
                Edit
              </a>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="5">
              <a href="#" @click="addUser()" class="btn btn-primary btn-sm">
                Add user
              </a>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <router-link class="btn btn-secondary mt-3" to="/secure/resellers">
      Back to list
    </router-link>
  </article>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import loading from '../mixins/loading'

export default {
  name: 'Reseller',
  mixins: [loading],
  data() {
    return {
      loading: {
        getReseller: false,
        getRateplans: false,
        getUsers: false,
        save: false,
        getAllRateplans: false,
      },
      reseller: {
        displayName: '',
        jasperWirelessCode: '',
      },
      rateplans: [],
      allRateplans: [],
      planToAdd: null,
      users: [],
      edit: false,
    }
  },
  validations: {
    reseller: {
      displayName: {
        required,
      },
      jasperWirelessCode: {
        required,
      },
    },
  },
  computed: {
    newReseller() {
      return this.$route.params.id === 'new'
    },
    filteredRateplans() {
      return this.allRateplans.filter(
        rateplan =>
          !this.rateplans.some(
            linkedRateplan => linkedRateplan.id === rateplan.id
          )
      )
    },
  },
  methods: {
    ...mapActions('toast', ['addToast']),
    getReseller(id) {
      this.loading.getReseller = true
      axios
        .get(`/rest/reseller/${id}`)
        .then(response => (this.reseller = response.data))
        .finally(() => (this.loading.getReseller = false))
    },
    getRateplans(id) {
      this.loading.getRateplans = true
      axios
        .get(`/rest/reseller/${id}/rateplan`)
        .then(response =>
          Promise.all(
            response.data.map(rateplanId => {
              return axios.get(`/rest/rateplan/${rateplanId}`)
            })
          )
        )
        .then(
          responses =>
            (this.rateplans = responses.reduce(
              (list, response) => list.concat(response.data),
              []
            ))
        )
        .finally(() => (this.loading.getRateplans = false))
    },
    getUsers(id) {
      this.loading.getUsers = true
      axios
        .get(`/rest/reseller/${id}/user`)
        .then(response => (this.users = response.data))
        .finally(() => (this.loading.getUsers = false))
    },
    getAllRateplans() {
      this.loading.getAllRateplans = true
      axios
        .get('/rest/rateplan/all')
        .then(response => {
          this.allRateplans = response.data
        })
        .finally(() => {
          this.loading.getAllRateplans = false
        })
    },
    save() {
      this.$v.reseller.$touch()
      if (this.$v.reseller.$invalid) {
        return
      }

      this.loading.save = true
      axios(`/rest/reseller/${this.reseller.id || ''}`, {
        method: this.reseller.id ? 'PUT' : 'POST',
        data: this.reseller,
      })
        .then(response => {
          if (!this.reseller.id) {
            this.reseller = response.data
            this.$router.replace(`/secure/resellers/${this.reseller.id}`)
          }

          this.addToast({
            message: `User ${this.reseller.displayName} saved`,
            type: 'success',
          })
          this.edit = false
        })
        .finally(() => (this.loading.save = false))
    },
    removePlan(plan) {
      this.loading.removePlan = true
      axios(`/rest/reseller/${this.reseller.id}/rateplan/${plan.id}`, {
        method: 'DELETE',
      })
        .then(() => {
          const index = this.rateplans.indexOf(plan)
          this.rateplans.splice(index, 1)

          this.addToast({
            message: `Plan ${plan.displayName} removed`,
            type: 'success',
          })
        })
        .finally(() => (this.loading.removePlan = false))
    },
    addPlan(plan) {
      this.loading.addPlan = true
      axios(`/rest/reseller/${this.reseller.id}/rateplan/${plan.id}`, {
        method: 'PUT',
      })
        .then(() => {
          this.rateplans.push(plan)

          this.addToast({
            message: `Plan ${plan.displayName} added`,
            type: 'success',
          })
        })
        .finally(() => (this.loading.addPlan = false))
    },
    editUser(user) {
      this.$router.push(
        `/secure/resellers/${this.reseller.id}/users/${user.id}`
      )
    },
    addUser() {
      this.$router.push(`/secure/resellers/${this.reseller.id}/users/new`)
    },
  },
  beforeMount() {
    if (!this.newReseller) {
      this.getReseller(this.$route.params.id)
      this.getRateplans(this.$route.params.id)
      this.getUsers(this.$route.params.id)
    } else {
      this.edit = true
    }
    this.getAllRateplans()
  },
}
</script>

<style lang="scss"></style>
